function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCudelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1095,
    height: 280.63,
    viewBox: "0 0 1095 280.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1095,
    height: 280.63,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.35,278.17C55.6,278.17,0,224.21,0,143.89c0-39.22,13.05-72.54,37.75-96.33S97.16,11.1,138,11.1C178.05,11.1,211,23.51,236.11,48L213.48,70.89c-18.29-19.58-45.08-30.66-74.77-30.66-59.13,0-98.86,41.81-98.86,104,0,62.67,40,104.78,99.6,104.78,34.05,0,61.32-13.38,81.16-39.78L244.91,231c-25,30.88-61.7,47.16-106.56,47.16",
    style: {
      fill: "#3a2bde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.47,274.47V14.8h100.6C707.9,14.8,740,27.09,763,50.34s35.11,55.89,35.11,94.29-12.14,71-35.11,94.3-55.05,35.54-92.88,35.54Zm38-29.12h62.59c52.49,0,87.76-40.48,87.76-100.72s-35.27-100.7-87.76-100.7H607.48Z",
    style: {
      fill: "#3a2bde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924,278.17c-57.51,0-94.67-37.31-94.67-95.05,0-59.31,36.29-97.64,92.45-97.64s92.46,36.59,92.46,93.2c0,4.81-.36,9.94-.75,14h-146l1.06,8c4.42,33.56,23.87,52.05,54.76,52.05a68.89,68.89,0,0,0,50.54-22l26.5,13.37c-17.58,21.73-44.94,34-76.3,34m-2.22-167.26c-29.69,0-48.62,19.13-53.28,53.87l-1.08,8h109l-1-7.94c-4.19-34.3-23.75-54-53.67-54",
    style: {
      fill: "#3a2bde"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.84,
    width: 36.16,
    height: 274.47,
    style: {
      fill: "#3a2bde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.51,280.63A127.81,127.81,0,0,1,269.84,153v-30.6h31.51V153a96.16,96.16,0,0,0,192.32,0v-30.6h31.51V153A127.81,127.81,0,0,1,397.51,280.63",
    style: {
      fill: "#3a2bde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9,85.48h0a27.41,27.41,0,1,0,27.41,27.41A27.41,27.41,0,0,0,348.9,85.48",
    style: {
      fill: "#3a2bde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.4,85.48h0a27.41,27.41,0,1,0,27.41,27.41A27.41,27.41,0,0,0,441.4,85.48",
    style: {
      fill: "#3a2bde"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCudelLogo);
export default __webpack_public_path__ + "static/media/cudel_logo.eff8a10a766b13cb55fa2da30c495cc2.svg";
export { ForwardRef as ReactComponent };